// src/components/forms/TextInput.tsx
import { FC } from "react";

interface Props {
  label: string;
  placeholder?: string;
  name: string;
  value?: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: "text" | "email" | "number" | "password";
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

export const TextInput: FC<Props> = ({ 
  label, 
  placeholder, 
  name, 
  value, 
  onChange, 
  type = "text", 
  className,
  disabled = false,
  readOnly = false,
  
}) => {
  return (
    <div className={`flex flex-col gap-2 mt-7 ${className}`}>
      {/* Label with a slight indigo tint */}
      <label className="text-sm font-bold uppercase text-slate-200 dark:text-indigo-200 ml-1">
        {label}
      </label>
      
      <div className="group relative">
        {/* Decorative Gradient Border Background - Hidden if disabled */}
        {!disabled && (
          <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 rounded-xl opacity-20 group-focus-within:opacity-100 transition duration-300 blur-[2px]"></div>
        )}
        
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value ?? ""} 
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          className="relative w-full rounded-xl bg-white dark:bg-zinc-900 px-4 py-2.5 
                     text-zinc-900 dark:text-zinc-100 
                     placeholder:text-zinc-400
                     border border-zinc-200 dark:border-zinc-700
                     focus:border-transparent focus:outline-none 
                     transition-all duration-200
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-zinc-50 dark:disabled:bg-zinc-800/50
                     read-only:bg-zinc-50 dark:read-only:bg-zinc-800/30"
        />
      </div>
    </div>
  );
};